<template>
    <nav class="ms-4">
        <ul>
            <li>
                <button class="js-menu hamurger-menu" type="button" id="navbarDropdown" role="button">
                    <span class="bar"></span>
                </button>
                <nav class="hamburger-menu-data" aria-labelledby="navbarDropdown">
                    <ul>
                        <li><a class="" href="/my_account">My Account</a></li>
                        <li><a class="" href="/offers">Offers</a></li>
                        <li><a class="" href="/transaction_details">Redemption History</a></li>
                        <li><a class="" @click="logout" href="#">Logout</a></li>
                    </ul>
                </nav>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: "NavBarComponent",
        data(){
            return {

            }
        },
        methods : {
            logout(e) {
                e.preventDefault();

                axios.post('/logout', {})
                    .then(response => {
                        // console.log(response);


                        if (response.status && response.status && response.status == 200) {
                            this.$router.push({name : 'sign_in'});
                        } else {
                            // this.$router.push('dashboard')
                        }
                    })
                    .catch(error => {
                        this.$router.push({name : 'sign_in'});
                        // if (error.response && error.response.data && error.response.status == 401) {
                        //     this.$router.push('sign_in')
                        // }
                        // console.error(error.response, 'here');

                    });

            },

            getUser(e) {

                e.preventDefault();

                axios.get('/get-user', {}).then(response => {
                    // console.log(response);

                })
                    .catch(error => {
                        console.error(error.response.status, 'here');
                        // console.error(error.status,'here')

                        if (error.response.status == 401) {
                            this.$router.push({name : 'sign_in'});
                        }
                    });

            },
        }

    }
</script>

<style scoped>

</style>

